module.exports = __webpack_public_path__ + "static/City Pantry-6fd7680577846880652e97da088b9109.jpg";